import { render, staticRenderFns } from "./item1.vue?vue&type=template&id=a6aa3aa2&scoped=true"
import script from "./item1.vue?vue&type=script&lang=js"
export * from "./item1.vue?vue&type=script&lang=js"
import style0 from "./item1.vue?vue&type=style&index=0&id=a6aa3aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aa3aa2",
  null
  
)

export default component.exports